export default "__VITE_ASSET__DYFhj4dc__"